




































































































import Vue from 'vue'

import { ApiService } from '@/services'
import dayjs from 'dayjs'

import OfferUnpin from '@/components/OfferUnpin.vue'
import WaitListModal from '@/components/waitList/WaitListModal.vue'

export default Vue.extend({
  name: 'ReservationCard',

  components: {
    OfferUnpin,
    WaitListModal,
  },

  props: {
    reservation: {
      type: Object,
      required: true,
    },
    cardType: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    showUnpinModal: false,
    showWaitListModal: false,
    leaveWaitListLoading: false,
  }),

  computed: {
    isReservationIncomplete: function () {
      return this.reservation.category === 'Active'
    },
    isReservationClaimed: function () {
      return this.reservation.category === 'Pinned'
    },
    isReservationWaitListed: function () {
      return this.reservation.category === 'Wait List'
    },
    isReservationComplete: function () {
      return this.reservation.category === 'Past'
    },
  },

  methods: {
    getOfferUrl: function (reservation) {
      const { voucher } = reservation

      if (reservation.category === 'Wait List') {
        this.showWaitListModal = true
        return
      }

      this.navigateToVoucher(voucher.id)
    },
    dateToDayWeek(s) {
      return dayjs(s).format('ddd MMM D')
    },
    getOfferImageGradient: function (reservation) {
      if (reservation.proofs.length === 0) return ''

      return 'to bottom, rgb(200,200,200, 0.2), rgb(120,120,120, 0.6)'
    },
    navigateToProof: function (proof) {
      window.open(proof.imgUrl, '_blank')
    },
    handleLeaveWaitListClicked: function (reservation) {
      this.leaveWaitListLoading = true

      ApiService.delete(`waitList/${reservation.wait_list.id}`).then(() => {
        this.$toast.success("Thanks! We've removed this offer from your wait list")

        this.$emit('reservation-list-refresh')
        this.$store.dispatch('reservations/fetchReservationSummary')
      })
    },
    handlePinUnpinned: function () {
      this.showUnpinModal = false

      this.$emit('reservation-list-refresh')
    },
  },
})
